import { render } from "./Modal_BusinessInvoice.vue?vue&type=template&id=beb7fa02"
import script from "./Modal_BusinessInvoice.vue?vue&type=script&lang=js"
export * from "./Modal_BusinessInvoice.vue?vue&type=script&lang=js"

import "./Modal_BusinessInvoice.vue?vue&type=style&index=0&id=beb7fa02&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__